<template>
  <div>
    <div class="row app-info-row pt-3">
      <div class="pb-3 bt-2">
        <h4><a :href="home_url"
               class="text-gray-500 border border-gray-500 bg-transparent px-4 pt-2 pb-2 cursor-pointer rounded">
          <span class="fa fa-arrow-left"></span> {{ transEdit('back') }}
        </a>
        </h4>
      </div>
    </div>
    <div class="dark-card card-rounded card-transparent">
      <div class="dark-card-header rounded-t">
        <div>
          <i class="fa fa-money"></i> {{ transEdit('therapist.reports.salary-invoice') }}
        </div>
      </div>

      <div class="dark-card-body">

        <form :action="portal_url">
          <input v-if="is_admin" type="hidden" name="portal_therapist_id" :value="therapist_id">
          <div class="row mb-4 mt-2">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-3">
                <label for="month_picker" class="block text-sm font-medium leading-5 text-gray-700">Välj månad</label>
                <select id="month_picker" name="month" @change="onChange($event)"
                        class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                  <option v-for="month in months" :value="month">{{ month }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <span class="text-red-500" v-if="!this.therapistHasCorrectInfo">
                Fyll i dina bankgirouppgifter på sidan <i>"Min information"</i> för att kunna hämta ut en rapport.
              </span>
            </div>
            <div class="col-sm-4">
              <button
                  :class="{'bg-gray-500' : !this.therapistHasCorrectInfo, 'bg-tlmblue2' : this.therapistHasCorrectInfo }"
                  class="rounded  text-white px-8 py-1" :disabled="!therapistHasCorrectInfo"><i
                  class="fa fa-download"></i> Hämta rapport
              </button>
            </div>
            <div class="col-sm-4">
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['home_url', 'portal_url', 'therapist_id', 'is_admin', 'months', 'current_date', 'month_ago', 'therapist'],
  name: "therapist-dash-reports",
  data: function () {
    return {
      monthAgo: this.month_ago,
      currentDate: this.current_date,
      end: null,
      start: null
    }
  },
  watch: {
    monthAgo: function (upd) {
      let date = new Date(upd)
      this.start = this.formattedDate(date);
    },
    currentDate: function (upd) {
      let date = new Date(upd);
      this.end = this.formattedDate(date);
    }
  },
  computed: {
    therapistHasCorrectInfo() {
      if (!this.therapist.bank_giro && !this.therapist.postal_giro && !this.therapist.bank_account_number) {
        return false;
      }

      if (!this.therapist.organizational_number && !this.therapist.vat_number && !this.therapist.identity_number) {
        return false;
      }

      return !(!this.therapist.user.name || !this.therapist.postalcode || !this.therapist.city || !this.therapist.user.email);
    }
  },
  methods: {
   
    formattedDate(date) {
      return date.getFullYear() + "-" + ('0' + (date.getMonth() + 1)).slice(-2) + "-" + ('0' + date.getDate()).slice(-2);
    }
  }
}
</script>
